import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TrainModal from '../../components/TrainModal'
import { getActiveTrain } from '../../redux/reducers/activeTrain'
import { resetActiveTrain } from '../../redux/actions/setActiveTrain'

const TrainsContainer = () => {
  const dispatch = useDispatch()
  const activeTrain = useSelector(getActiveTrain)

  const closeModal = () => {
    dispatch(resetActiveTrain())
  }

  return (
    <TrainModal
      train={activeTrain}
      isOpen={!!activeTrain}
      onClose={closeModal}
    />
  )
}

export default TrainsContainer
